// extracted by mini-css-extract-plugin
export default {"wrapper":"ReportDownLoadList_wrapper__puD5h"};